import { ExternalUrls } from '../interfaces/ExternalUrls';

export const externalUrls: ExternalUrls = {
  fidesForClients: 'https://www.fides.ch/en/for-clients/',
  eftNewOrder: '/#!/app/order/editor/',
  eftMobileOrderOverview: '/#!/mobile/order/overview',
};
